import {TargetBlank} from '@wandb/weave/common/util/links';
import React from 'react';

import {accountSettingsBillingTab} from '../../../util/urls';

export const BenefitsText = ({
  savingsIfSwitchToAnnual,
}: {
  savingsIfSwitchToAnnual?: number;
}) => {
  if (savingsIfSwitchToAnnual != null) {
    return (
      <>
        and immediately get 5,000 tracking hours, 2 months free, and save{' '}
        {savingsIfSwitchToAnnual.toLocaleString('us-en', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0,
        })}
        .
      </>
    );
  }

  return <>and immediately get 5,000 tracking hours and 2 months free.</>;
};

export const BillingAdminMonthlyCTAText = ({
  organizationName,
  savingsIfSwitchToAnnual,
}: {
  organizationName: string;
  savingsIfSwitchToAnnual?: number;
}) => (
  <>
    <TargetBlank
      href={accountSettingsBillingTab(organizationName)}
      className="text-sienna-600 underline hover:text-sienna-500">
      Upgrade to an annual plan
    </TargetBlank>{' '}
    <BenefitsText savingsIfSwitchToAnnual={savingsIfSwitchToAnnual} />
  </>
);

export const NonBillingAdminMonthlyCTAText = ({
  billingAdminEmail,
  savingsIfSwitchToAnnual,
}: {
  billingAdminEmail: string;
  savingsIfSwitchToAnnual?: number;
}) => (
  <>
    Contact {billingAdminEmail} to upgrade to an annual plan{' '}
    <BenefitsText savingsIfSwitchToAnnual={savingsIfSwitchToAnnual} />
  </>
);
